import { render, staticRenderFns } from "./CameraCaptura.vue?vue&type=template&id=5c26794c&scoped=true"
import script from "./CameraCaptura.vue?vue&type=script&lang=js"
export * from "./CameraCaptura.vue?vue&type=script&lang=js"
import style0 from "./CameraCaptura.vue?vue&type=style&index=0&id=5c26794c&prod&scoped=true&lang=css"
import style1 from "./CameraCaptura.vue?vue&type=style&index=1&id=5c26794c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c26794c",
  null
  
)

export default component.exports